import {wonlexCopy} from './wonlex-copy.js';
import {phonePushEn,phonePushDa} from "./push-copy.js";
import { gpsCopy } from "./gps-copy.js";
import { productCopy } from "./product-copy.js";
import { layoutCopy } from "./layout-copy.js";
import { fitnessCopy } from "./fitness-copy.js";
import { expansionCopy } from "./expansion-copy.js";
import { localCopy } from "./local-copy.js";
import { activityCopy } from "./activity-copy.js";
import { hardwareCopy } from "./hardware-copy.js";
import { settingsCopy } from "./settings-copy.js";
import { archiveCopy } from "./archive-copy.js";
import { contactCopy } from "./contact-copy.js";

import { trackerPasswordCopy } from "./tracker-password-copy.js";
import { accountCopy } from "./account-copy.js";

export const sourceLocale = "en-GB";

export const catalogues = {
  "en-GB": {
    ...gpsCopy["en-GB"],
    ...trackerPasswordCopy["en-GB"],
    ...accountCopy["en-GB"],
    ...layoutCopy["en-GB"],
    ...fitnessCopy["en-GB"],
    ...expansionCopy["en-GB"],
    ...contactCopy["en-GB"],
    ...archiveCopy["en-GB"],
    ...localCopy["en-GB"],
    ...activityCopy["en-GB"],
    ...hardwareCopy["en-GB"],
    ...settingsCopy["en-GB"],...wonlexCopy["en-GB"],
    "app.name": "Qtracker",
    "app.prototype": "Preview",
    "auth.title": "Welcome back",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.submit": "Sign in",
    "overview.title": "Overview",
    "overview.greeting": "Good afternoon",
    "overview.safeTitle": "Everything looks good",
    "overview.safeBody": "Mila is at home and the tracker is online.",
    "overview.staleTitle": "Location needs an update",
    "overview.staleBody": "The tracker is online, but the last position is getting old.",
    "overview.batteryTitle": "Battery is running low",
    "overview.batteryBody": "Charge the tracker soon to keep protection active.",
    "overview.alarmTitle": "SOS alarm received",
    "overview.alarmBody": "Mila may need help. Review the location and acknowledge the alarm.",
    "overview.lastContact": "Last contact",
    "overview.battery": "Battery",
    "overview.signal": "Signal",
    "overview.steps": "Steps today",
    "overview.position": "Latest position",
    "overview.atHome": "At home",
    "overview.insideSafeZone": "Inside Home safe zone",
    "overview.outsideSafeZone": "Outside Home safe zone",
    "position.request": "Request new position",
    "position.pending": "Requesting position…",
    "position.requested": "Position request sent",
    "map.title": "Map",
    "map.latestFix": "Latest location",
    "map.live": "Live",
    "map.accuracy": "Accuracy",
    "map.method": "Method",
    "map.safeZone": "Home safe zone",
    "map.updated": "Updated {time}",
    "map.demoAddress": "Harbour Road 12",
    "events.title": "Events",
    "events.all": "All",
    "events.critical": "Critical",
    "events.system": "System",
    "events.alarmUnclassified": "Alarm received",
    "events.sos": "SOS alarm",
    "events.lowBattery": "Low battery",
    "events.locationUpdated": "Location updated",
    "events.trackerConnected": "Tracker connected successfully",
    "events.protocolAcknowledged": "Device replied",
    "events.caregiverPending": "Awaiting response",
    "events.acknowledged": "Marked as handled by you",
    "events.acknowledge": "Mark as handled",
    "events.empty": "No events match this filter.",
    "feature.section.location": "Location & zones",
    "feature.section.care": "Health & daily care",
    "feature.section.communication": "Calls & voice",
    "feature.section.safety": "Safety and settings",
    "feature.section.device": "Device & support",
    "feature.section.account": "Account & access",
    "feature.locationSources": "Location sources",
    "feature.locationSourcesSummary": "GPS, LBS and Wi-Fi filtering",
    "feature.uploadInterval": "Position interval",
    "feature.uploadIntervalSummary": "Power saving or scheduled position updates",
    "feature.routeHistory": "Route history",
    "feature.routeHistorySummary": "Times and saved routes",
    "feature.gpsFence": "GPS safe zone",
    "feature.gpsFenceSummary": "Map centre, radius and boundary alarms",
    "feature.wifiFence": "Wi-Fi safe zone",
    "feature.wifiFenceSummary": "A 2.4 GHz BSSID-based home zone",
    "feature.heartPressure": "Heart rate & blood pressure",
    "feature.heartPressureSummary": "History, limits and one-time measurement",
    "feature.activity": "Steps, energy & distance",
    "feature.activitySummary": "Daily activity and calculation settings",
    "feature.medication": "Medication reminders",
    "feature.medicationSummary": "Once, daily or custom reminder slots",
    "feature.temperature": "Temperature",
    "feature.temperatureSummary": "Previous and new temperature readings",
    "feature.oxygen": "Blood oxygen",
    "feature.oxygenSummary": "Previous and new oxygen readings",
    "feature.callTracker": "Call tracker",
    "feature.callTrackerSummary": "Start a normal telephone call",
    "feature.voiceTalk": "Voice talk",
    "feature.voiceTalkSummary": "Exchange short voice clips with the tracker",
    "feature.voiceMonitor": "Voice monitoring",
    "feature.voiceMonitorSummary": "Privacy-sensitive remote listening",
    "feature.sosNumbers": "SOS numbers",
    "feature.sosNumbersSummary": "Three prioritised emergency contacts",
    "feature.phonebook": "Phonebook",
    "feature.phonebookSummary": "Approved contacts available on the tracker",
    "feature.smsAlarm": "SMS alarms",
    "feature.smsAlarmSummary": "Send selected tracker alarms by SMS",
    "feature.removalAlarm": "Removal alarm",
    "feature.removalAlarmSummary": "Alert when the tracker is removed",
    "feature.safeMode": "Safe mode",
    "feature.safeModeSummary": "Allow calls only from phonebook and SOS numbers",
    "feature.sceneMode": "Sound profile",
    "feature.sceneModeSummary": "Sound, vibration or silent behaviour",
    "feature.alarmClock": "Alarm clock",
    "feature.alarmClockSummary": "Once, daily or custom tracker alarms",
    "feature.findTracker": "Find tracker",
    "feature.findTrackerSummary": "Ring the tracker for about one minute",
    "feature.answerMode": "Answer incoming calls",
    "feature.answerModeSummary": "Press to answer or hands-free answering",
    "feature.speakingClock": "Speaking clock",
    "feature.speakingClockSummary": "Read the time aloud on the tracker",
    "feature.callerId": "Incoming phone-number announcement",
    "feature.callerIdSummary": "Read the incoming phone number aloud in English",
    "feature.fallAlarm": "Fall alarm",
    "feature.fallAlarmSummary": "Alarm and optional call after a detected fall",
    "feature.fallSensitivity": "Fall sensitivity",
    "feature.fallSensitivitySummary": "Detection level tied to the firmware profile",
    "feature.powerSchedule": "Power schedule",
    "feature.powerScheduleSummary": "Scheduled tracker power-on and power-off",
    "feature.deviceInfo": "About the device",
    "feature.deviceInfoSummary": "Model, masked identifiers, firmware and filters",
    "feature.languageTimezone": "Tracker language & time zone",
    "feature.languageTimezoneSummary": "Device speech language and time",
    "feature.notifications": "App notifications",
    "feature.notificationsSummary": "Phone notifications, sound and vibration",
    "feature.restart": "Restart tracker",
    "feature.restartSummary": "Remote restart with audit and confirmation",
    "feature.powerOff": "Power off tracker",
    "feature.powerOffSummary": "Remote power-off can interrupt protection",
    "feature.factoryReset": "Factory reset",
    "feature.factoryResetSummary": "Erase tracker configuration after verification",
    "feature.faq": "Help and questions",
    "feature.faqSummary": "SIM, APN, PIN, network and tracker help",
    "feature.userLogin": "User sign-in",
    "feature.userLoginSummary": "Sign in to your account",
    "feature.deviceBinding": "Add or bind tracker",
    "feature.deviceBindingSummary": "Device ID, control password or QR code",
    "feature.password": "Change password",
    "feature.passwordSummary": "Change your account password or device SMS code",
    "feature.logout": "Sign out",
    "feature.logoutSummary": "Sign out on this device",
    "feature.status.ready": "Available in preview",
    "feature.status.demo": "Preview",
    "feature.status.gated": "Hardware validation required",
    "feature.status.locked": "Safety locked",
    "feature.status.readyBody": "View the feature with example data.",
    "feature.status.demoBody": "Choices apply to the preview only. Your device is unchanged.",
    "feature.status.gatedBody": "The complete screen can be tested, but sending the command waits for a confirmed firmware profile.",
    "feature.status.lockedBody": "This function is visible but cannot be executed until privacy, rollback and audit controls are approved.",
    "feature.save": "Save preview choices",
    "feature.saved": "Your choice is saved in the preview. Your device is unchanged.",
    "feature.actionComplete": "Preview completed",
    "feature.historyTitle": "Example data",
    "feature.historyBody": "Example · three records",
    "feature.deviceInfoBody": "View device firmware version, SIM information and connection. Missing information is shown as unknown.",
    "feature.faqBody": "Check that the device is on and its SIM card has mobile data and coverage. Contact Qtracker if it still cannot connect.",
    "control.filterLbs": "Filter LBS positions",
    "control.filterWifi": "Filter Wi-Fi positions",
    "control.deviceName": "Device name",
    "control.devicePhone": "Device phone number",
    "control.interval": "Position interval",
    "control.period": "Period",
    "control.showLbs": "Show approximate cell-tower positions",
    "control.enabled": "Enabled",
    "control.radius": "Radius in metres",
    "control.alarmDirection": "Alarm direction",
    "control.fenceName": "Zone name",
    "control.bssid": "Wi-Fi network address",
    "control.measureNow": "Start one-time measurement",
    "control.lowPulse": "Low pulse limit",
    "control.highPulse": "High pulse limit",
    "control.stride": "Stride length in centimetres",
    "control.weight": "Weight in kilograms",
    "control.repeat": "Repeat",
    "control.time": "Time",
    "control.message": "Reminder text",
    "control.measurementMode": "Measurement mode",
    "control.startCall": "Preview a call",
    "control.holdToTalk": "Hold to record a preview",
    "control.sos1": "SOS contact 1",
    "control.sos2": "SOS contact 2",
    "control.sos3": "SOS contact 3",
    "control.contactName": "Contact name",
    "control.contactNumber": "Contact number",
    "control.notificationMethod": "Notification method",
    "control.scene": "Sound profile",
    "control.ringTracker": "Preview Find",
    "control.answerMode": "Answer incoming calls",
    "control.callOnAlarm": "Call SOS contact after alarm",
    "control.sensitivity": "Sensitivity level",
    "control.scheduledOn": "Scheduled power-on",
    "control.onTime": "Power-on time",
    "control.scheduledOff": "Scheduled power-off",
    "control.offTime": "Power-off time",
    "control.trackerLanguage": "Tracker voice language",
    "control.timezone": "Time offset",
    "control.sound": "Phone ringtone",
    "control.vibration": "Phone vibration",
    "control.rememberLogin": "Remember sign-in",
    "control.scanQr": "Preview QR scanning",
    "control.currentPassword": "Current password",
    "control.newPassword": "New password",
    "control.repeatPassword": "Repeat new password",
    "option.powerSave": "Power saving",
    "option.1m": "1 minute",
    "option.10m": "10 minutes",
    "option.1h": "1 hour",
    "option.6h": "6 hours",
    "option.12h": "12 hours",
    "option.today": "Today",
    "option.yesterday": "Yesterday",
    "option.custom": "Custom",
    "option.enter": "Entering",
    "option.leave": "Leaving",
    "option.both": "Entering and leaving",
    "option.once": "Once",
    "option.daily": "Daily",
    "option.cycle": "Repeat",
    "option.scheduled": "Scheduled",
    "option.push": "Phone notification",
    "option.sms": "SMS",
    "option.call": "Telephone call",
    "option.soundVibrate": "Sound and vibration",
    "option.sound": "Sound",
    "option.vibrate": "Vibration",
    "option.silent": "Silent",
    "option.press": "Press to answer",
    "option.handsFree": "Hands-free auto-answer",
    "option.english": "English",
    "option.danish": "Danish",
    "option.swedish": "Swedish",
    "option.norwegian": "Norwegian",
    "device.title": "Device",
    "device.tracker": "Tracker",
    "device.model": "Model",
    "device.identifier": "Device ID",
    "device.firmware": "Firmware version",
    "device.network": "Network",
    "device.sim": "SIM status",
    "device.connected": "Connected",
    "device.apn": "APN",
    "device.safety": "Safety",
    "device.safeZone": "Safe zone",
    "device.contacts": "Emergency contacts",
    "device.profile": "Device model",
    "device.unresolved": "Setup required",
    "device.trackerDescription": "Qtracker device",
    "device.protectedIdentifier": "Device ID",
    "device.contactsConfigured": "{count} saved",
    "device.settings": "App settings",
    "device.language": "Language",
    "device.appearance": "Appearance",
    "device.readOnly": "This is a preview. Your device is unchanged.",
    "status.justNow": "Just now",
    "status.minutesAgo": "{count} min ago",
    "status.online": "Online",
    "status.attention": "Needs attention",
    "status.critical": "Critical alarm",
    "status.unknown": "Unknown",
    "status.good": "Good",
    "care.demoReadings": "Example readings",
    "care.pulse": "Pulse",
    "care.temperature": "Temperature",
    "care.oxygen": "Blood oxygen",
    "care.disclaimer": "Wellness readings are not a diagnosis or a substitute for medical equipment.",
    "navigation.overview": "Overview",
    "navigation.map": "Map",
    "navigation.care": "Care",
    "navigation.events": "Events",
    "navigation.device": "Device",
    "preview.title": "Show preview",
    "preview.normal": "Normal",
    "preview.stale": "Stale position",
    "preview.lowBattery": "Low battery",
    "preview.alarm": "SOS alarm",
    "preview.nextState": "Next preview",
    "preview.currentState": "Preview: {state}",
    "preview.demo": "Preview",
    "appearance.light": "Light",
    "appearance.dark": "Dark",
    "common.close": "Close",
    "common.notAvailable": "Not available",
  },
  "da-DK": {
    ...gpsCopy["da-DK"],
    ...trackerPasswordCopy["da-DK"],
    ...accountCopy["da-DK"],
    ...layoutCopy["da-DK"],
    ...fitnessCopy["da-DK"],
    ...expansionCopy["da-DK"],
    ...contactCopy["da-DK"],
    ...archiveCopy["da-DK"],
    ...localCopy["da-DK"],
    ...activityCopy["da-DK"],
    ...hardwareCopy["da-DK"],
    ...settingsCopy["da-DK"],...wonlexCopy["da-DK"],
    "app.name": "Qtracker",
    "app.prototype": "Eksempelvisning",
    "auth.title": "Velkommen tilbage",
    "auth.email": "E-mail",
    "auth.password": "Adgangskode",
    "auth.submit": "Log ind",
    "overview.title": "Overblik",
    "overview.greeting": "God eftermiddag",
    "overview.safeTitle": "Alt ser godt ud",
    "overview.safeBody": "Mila er hjemme, og trackeren er online.",
    "overview.staleTitle": "Positionen bør opdateres",
    "overview.staleBody": "Trackeren er online, men den seneste position er ved at være gammel.",
    "overview.batteryTitle": "Batteriet er ved at være lavt",
    "overview.batteryBody": "Oplad trackeren snart for at bevare beskyttelsen.",
    "overview.alarmTitle": "SOS-alarm modtaget",
    "overview.alarmBody": "Mila kan have brug for hjælp. Kontrollér positionen og kvittér alarmen.",
    "overview.lastContact": "Seneste kontakt",
    "overview.battery": "Batteri",
    "overview.signal": "Signal",
    "overview.steps": "Skridt i dag",
    "overview.position": "Seneste position",
    "overview.atHome": "Hjemme",
    "overview.insideSafeZone": "Inden for Hjem-sikkerhedszonen",
    "overview.outsideSafeZone": "Uden for Hjem-sikkerhedszonen",
    "position.request": "Hent ny position",
    "position.pending": "Henter position…",
    "position.requested": "Positionsanmodning sendt",
    "map.title": "Kort",
    "map.latestFix": "Seneste position",
    "map.live": "Aktuel",
    "map.accuracy": "Nøjagtighed",
    "map.method": "Metode",
    "map.safeZone": "Hjem-sikkerhedszone",
    "map.updated": "Opdateret {time}",
    "map.demoAddress": "Havnevej 12",
    "events.title": "Hændelser",
    "events.all": "Alle",
    "events.critical": "Kritiske",
    "events.system": "System",
    "events.alarmUnclassified": "Alarm modtaget",
    "events.sos": "SOS-alarm",
    "events.lowBattery": "Lavt batteri",
    "events.locationUpdated": "Position opdateret",
    "events.trackerConnected": "Trackeren blev forbundet",
    "events.protocolAcknowledged": "Enheden har svaret",
    "events.caregiverPending": "Afventer håndtering",
    "events.acknowledged": "Markeret som håndteret af dig",
    "events.acknowledge": "Markér som håndteret",
    "events.empty": "Ingen hændelser matcher dette filter.",
    "feature.section.location": "Position og zoner",
    "feature.section.care": "Sundhed og daglig omsorg",
    "feature.section.communication": "Opkald og tale",
    "feature.section.safety": "Tryghed og indstillinger",
    "feature.section.device": "Enhed og hjælp",
    "feature.section.account": "Konto og adgang",
    "feature.locationSources": "Positionskilder",
    "feature.locationSourcesSummary": "GPS-, LBS- og Wi-Fi-filtrering",
    "feature.uploadInterval": "Positionsinterval",
    "feature.uploadIntervalSummary": "Strømbesparelse eller planlagte positionsopdateringer",
    "feature.routeHistory": "Rutehistorik",
    "feature.routeHistorySummary": "Tidspunkter og gemte ruter",
    "feature.gpsFence": "GPS-sikkerhedszone",
    "feature.gpsFenceSummary": "Kortcentrum, radius og grænsealarmer",
    "feature.wifiFence": "Wi-Fi-sikkerhedszone",
    "feature.wifiFenceSummary": "En hjemmezone baseret på 2,4 GHz BSSID",
    "feature.heartPressure": "Puls og blodtryk",
    "feature.heartPressureSummary": "Historik, grænser og engangsmåling",
    "feature.activity": "Skridt, energi og distance",
    "feature.activitySummary": "Daglig aktivitet og beregningsindstillinger",
    "feature.medication": "Medicinpåmindelser",
    "feature.medicationSummary": "Engangs-, daglige eller tilpassede påmindelser",
    "feature.temperature": "Temperatur",
    "feature.temperatureSummary": "Tidligere målinger og nye temperaturmålinger",
    "feature.oxygen": "Iltmætning",
    "feature.oxygenSummary": "Tidligere målinger og ny iltmåling",
    "feature.callTracker": "Ring til tracker",
    "feature.callTrackerSummary": "Start et almindeligt telefonopkald",
    "feature.voiceTalk": "Talesamtale",
    "feature.voiceTalkSummary": "Udveksl korte talebeskeder med trackeren",
    "feature.voiceMonitor": "Talemonitorering",
    "feature.voiceMonitorSummary": "Privatlivsfølsom fjernlytning",
    "feature.sosNumbers": "SOS-numre",
    "feature.sosNumbersSummary": "Tre prioriterede nødkontakter",
    "feature.phonebook": "Telefonbog",
    "feature.phonebookSummary": "Godkendte kontakter på trackeren",
    "feature.smsAlarm": "SMS-alarmer",
    "feature.smsAlarmSummary": "Send udvalgte trackeralarmtyper via SMS",
    "feature.removalAlarm": "Afmonteringsalarm",
    "feature.removalAlarmSummary": "Advar, når trackeren bliver taget af",
    "feature.safeMode": "Sikker tilstand",
    "feature.safeModeSummary": "Tillad kun opkald fra telefonbogens numre og SOS-numre",
    "feature.sceneMode": "Lydprofil",
    "feature.sceneModeSummary": "Lyd, vibration eller lydløs adfærd",
    "feature.alarmClock": "Vækkeur",
    "feature.alarmClockSummary": "Engangs-, daglige eller tilpassede alarmer",
    "feature.findTracker": "Find tracker",
    "feature.findTrackerSummary": "Lad trackeren ringe i cirka ét minut",
    "feature.answerMode": "Besvar indgående opkald",
    "feature.answerModeSummary": "Tryk for at svare eller håndfri besvarelse",
    "feature.speakingClock": "Taleur",
    "feature.speakingClockSummary": "Læs klokkeslættet højt på trackeren",
    "feature.callerId": "Oplæsning af indgående telefonnummer",
    "feature.callerIdSummary": "Læs det indgående telefonnummer højt på engelsk",
    "feature.fallAlarm": "Faldalarm",
    "feature.fallAlarmSummary": "Alarm og valgfrit opkald efter registreret fald",
    "feature.fallSensitivity": "Faldfølsomhed",
    "feature.fallSensitivitySummary": "Registreringsniveau knyttet til firmwareprofilen",
    "feature.powerSchedule": "Tidsstyret tænd/sluk",
    "feature.powerScheduleSummary": "Planlagt tænding og slukning af trackeren",
    "feature.deviceInfo": "Om enheden",
    "feature.deviceInfoSummary": "Model, maskerede id'er, firmware og filtre",
    "feature.languageTimezone": "Trackersprog og tidszone",
    "feature.languageTimezoneSummary": "Enhedens talesprog og klokkeslæt",
    "feature.notifications": "Appnotifikationer",
    "feature.notificationsSummary": "Beskeder, lyd og vibration på telefonen",
    "feature.restart": "Genstart tracker",
    "feature.restartSummary": "Fjerngenstart med audit og bekræftelse",
    "feature.powerOff": "Sluk tracker",
    "feature.powerOffSummary": "Fjernslukning kan afbryde tryghedsfunktionen",
    "feature.factoryReset": "Fabriksnulstilling",
    "feature.factoryResetSummary": "Slet trackeropsætningen efter kontrol",
    "feature.faq": "Hjælp og spørgsmål",
    "feature.faqSummary": "Hjælp til SIM, APN, PIN, netværk og tracker",
    "feature.userLogin": "Brugerlogin",
    "feature.userLoginSummary": "Log ind på din konto",
    "feature.deviceBinding": "Tilføj eller tilknyt tracker",
    "feature.deviceBindingSummary": "Enheds-ID, kontrolkode eller QR-kode",
    "feature.password": "Skift adgangskode",
    "feature.passwordSummary": "Skift kontoens adgangskode eller enhedens SMS-kode",
    "feature.logout": "Log ud",
    "feature.logoutSummary": "Log ud på denne enhed",
    "feature.status.ready": "Tilgængelig i eksemplet",
    "feature.status.demo": "Eksempel",
    "feature.status.gated": "Kræver hardwarekontrol",
    "feature.status.locked": "Sikkerhedslåst",
    "feature.status.readyBody": "Se funktionen med eksempeldata.",
    "feature.status.demoBody": "Valgene gælder kun eksemplet. Din enhed ændres ikke.",
    "feature.status.gatedBody": "Hele skærmen kan testes, men afsendelse venter på en bekræftet firmwareprofil.",
    "feature.status.lockedBody": "Funktionen er synlig, men kan ikke udføres, før privatliv, rollback og audit er godkendt.",
    "feature.save": "Gem eksempelvalg",
    "feature.saved": "Valget er gemt i eksemplet. Din enhed er ikke ændret.",
    "feature.actionComplete": "Eksempel gennemført",
    "feature.historyTitle": "Eksempeldata",
    "feature.historyBody": "Eksempel · tre registreringer",
    "feature.deviceInfoBody": "Se enhedens firmwareversion, SIM-oplysninger og forbindelse. Oplysninger, der mangler, vises som ukendte.",
    "feature.faqBody": "Kontrollér, at enheden er tændt, og at SIM-kortet har mobildata og dækning. Kontakt Qtracker, hvis den stadig ikke får forbindelse.",
    "control.filterLbs": "Filtrér LBS-positioner",
    "control.filterWifi": "Filtrér Wi-Fi-positioner",
    "control.deviceName": "Enhedsnavn",
    "control.devicePhone": "Enhedens telefonnummer",
    "control.interval": "Positionsinterval",
    "control.period": "Periode",
    "control.showLbs": "Vis omtrentlige positioner fra mobilmaster",
    "control.enabled": "Aktiveret",
    "control.radius": "Radius i meter",
    "control.alarmDirection": "Alarmretning",
    "control.fenceName": "Zonenavn",
    "control.bssid": "Wi-Fi-netværkets adresse",
    "control.measureNow": "Start engangsmåling",
    "control.lowPulse": "Nedre pulsgrænse",
    "control.highPulse": "Øvre pulsgrænse",
    "control.stride": "Skridtlængde i centimeter",
    "control.weight": "Vægt i kilogram",
    "control.repeat": "Gentagelse",
    "control.time": "Tidspunkt",
    "control.message": "Påmindelsestekst",
    "control.measurementMode": "Måletilstand",
    "control.startCall": "Prøv opkald i eksemplet",
    "control.holdToTalk": "Hold for at optage et eksempel",
    "control.sos1": "SOS-kontakt 1",
    "control.sos2": "SOS-kontakt 2",
    "control.sos3": "SOS-kontakt 3",
    "control.contactName": "Kontaktnavn",
    "control.contactNumber": "Kontaktnummer",
    "control.notificationMethod": "Notifikationsmetode",
    "control.scene": "Lydprofil",
    "control.ringTracker": "Prøv Find i eksemplet",
    "control.answerMode": "Besvar indgående opkald",
    "control.callOnAlarm": "Ring til SOS-kontakt efter alarm",
    "control.sensitivity": "Følsomhedsniveau",
    "control.scheduledOn": "Planlagt tænding",
    "control.onTime": "Tændingstidspunkt",
    "control.scheduledOff": "Planlagt slukning",
    "control.offTime": "Slukningstidspunkt",
    "control.trackerLanguage": "Trackerens stemmesprog",
    "control.timezone": "Tidsforskel",
    "control.sound": "Telefonringetone",
    "control.vibration": "Telefonvibration",
    "control.rememberLogin": "Husk login",
    "control.scanQr": "Prøv QR-scanning i eksemplet",
    "control.currentPassword": "Nuværende adgangskode",
    "control.newPassword": "Ny adgangskode",
    "control.repeatPassword": "Gentag ny adgangskode",
    "option.powerSave": "Strømbesparelse",
    "option.1m": "1 minut",
    "option.10m": "10 minutter",
    "option.1h": "1 time",
    "option.6h": "6 timer",
    "option.12h": "12 timer",
    "option.today": "I dag",
    "option.yesterday": "I går",
    "option.custom": "Tilpasset",
    "option.enter": "Ved ankomst",
    "option.leave": "Ved afgang",
    "option.both": "Ved ankomst og afgang",
    "option.once": "Én gang",
    "option.daily": "Dagligt",
    "option.cycle": "Gentagelse",
    "option.scheduled": "Tidsstyret",
    "option.push": "Telefonbesked",
    "option.sms": "SMS",
    "option.call": "Telefonopkald",
    "option.soundVibrate": "Lyd og vibration",
    "option.sound": "Lyd",
    "option.vibrate": "Vibration",
    "option.silent": "Lydløs",
    "option.press": "Tryk for at svare",
    "option.handsFree": "Håndfri automatisk besvarelse",
    "option.english": "Engelsk",
    "option.danish": "Dansk",
    "option.swedish": "Svensk",
    "option.norwegian": "Norsk",
    "device.title": "Enhed",
    "device.tracker": "Tracker",
    "device.model": "Model",
    "device.identifier": "Enheds-ID",
    "device.firmware": "Firmwareversion",
    "device.network": "Netværk",
    "device.sim": "SIM-status",
    "device.connected": "Forbundet",
    "device.apn": "APN",
    "device.safety": "Tryghed",
    "device.safeZone": "Sikkerhedszone",
    "device.contacts": "Nødkontakter",
    "device.profile": "Enhedsmodel",
    "device.unresolved": "Opsætning mangler",
    "device.trackerDescription": "Qtracker-enhed",
    "device.protectedIdentifier": "Enhedens ID",
    "device.contactsConfigured": "{count} gemt",
    "device.settings": "Appindstillinger",
    "device.language": "Sprog",
    "device.appearance": "Udseende",
    "device.readOnly": "Dette er et eksempel. Din enhed ændres ikke.",
    "status.justNow": "Lige nu",
    "status.minutesAgo": "For {count} min. siden",
    "status.online": "Online",
    "status.attention": "Kræver opmærksomhed",
    "status.critical": "Kritisk alarm",
    "status.unknown": "Ukendt",
    "status.good": "Godt",
    "care.demoReadings": "Eksempelmålinger",
    "care.pulse": "Puls",
    "care.temperature": "Temperatur",
    "care.oxygen": "Iltmætning",
    "care.disclaimer": "Velværdimålinger er ikke en diagnose eller en erstatning for medicinsk udstyr.",
    "navigation.overview": "Overblik",
    "navigation.map": "Kort",
    "navigation.care": "Omsorg",
    "navigation.events": "Hændelser",
    "navigation.device": "Enhed",
    "preview.title": "Vis eksempel",
    "preview.normal": "Normal",
    "preview.stale": "Gammel position",
    "preview.lowBattery": "Lavt batteri",
    "preview.alarm": "SOS-alarm",
    "preview.nextState": "Næste eksempel",
    "preview.currentState": "Eksempel: {state}",
    "preview.demo": "Eksempelvisning",
    "appearance.light": "Lys",
    "appearance.dark": "Mørk",
    "common.close": "Luk",
    "common.notAvailable": "Ikke tilgængelig",
  },
};

for (const locale of Object.keys(catalogues)) Object.assign(catalogues[locale], productCopy[locale]);

Object.assign(catalogues["en-GB"],phonePushEn);
Object.assign(catalogues["da-DK"],phonePushDa);
Object.assign(catalogues['da-DK'],{'hardware.alarm.vibration':'Rystealarm','hardware.alarm.power_cut':'Ekstern strøm afbrudt','hardware.alarm.overspeed':'Hastighedsgrænse overskredet'});
Object.assign(catalogues['en-GB'],{'hardware.alarm.vibration':'Vibration alert','hardware.alarm.power_cut':'External power disconnected','hardware.alarm.overspeed':'Speed limit exceeded'});

export function translate(locale, key, parameters = {}) {
  const template = catalogues[locale]?.[key] ?? catalogues[sourceLocale][key] ?? (locale === "en-GB" ? "Information unavailable" : "Oplysningen er ikke tilgængelig");
  return template.replace(/\{([A-Za-z0-9_]+)\}/g, (_, name) => String(parameters[name] ?? `{${name}}`));
}
